import React, { useEffect } from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { Outlet, useLocation } from "react-router-dom";
import useReducerHook from "../../hooks/useReducerHook";
import { fetchMenuData } from "../../redux/Slice/PageMenu";
import { useDispatch } from "react-redux";


const Layout = () => {
  // const dispatch = useDispatch();
  // const location = useLocation();
  // const { pageMenus } = useReducerHook();

  // useEffect(() => {
  //   dispatch(fetchMenuData());
  // }, []);

  // const menuData = pageMenus?.menuData || [];
  // if (menuData.length === 0) {
  //   return null;
  // }

 
  // const pagesData = menuData.map((x) => ({
  //   ...x,
  //   page_slug: x?.page_slug === "home" ? "" : x?.page_slug,
  // }));

  // const matchedPage = pagesData.find(
  //   (x) => `/${x?.page_slug}` === location.pathname
  // );
  // if (!matchedPage) {
  //   return null; 
  // }

  return (
    <>
      <Header />
      <div className="main">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Layout;
